import { render, staticRenderFns } from "./outpatients.vue?vue&type=template&id=2aefc159&scoped=true&"
import script from "./outpatients.vue?vue&type=script&lang=js&"
export * from "./outpatients.vue?vue&type=script&lang=js&"
import style0 from "./outpatients.vue?vue&type=style&index=0&id=2aefc159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefc159",
  null
  
)

export default component.exports